export const name = 'serviceRegistrar' as const
